import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ActionBlock from 'components/common/ActionBlock';
import { MFA_METHOD_DISPLAY_NAMES, MfaMethod } from './MFAService';

type MFAMethodItemProps = {
  method: MfaMethod;
  onRemove: (id: string) => void;
  disabled?: boolean;
};

const MFAMethodItem: FC<MFAMethodItemProps> = ({
  method,
  onRemove,
  disabled,
}) => {
  const { t } = useTranslation();
  const displayName = MFA_METHOD_DISPLAY_NAMES[method.type] ?? method.type;

  return (
    <ActionBlock
      data-test-mfa-method-item
      fieldValue={displayName}
      dataModifyLink={t('signInSecurity.mfa.remove')}
      onClickHandler={disabled ? undefined : () => onRemove(method.id)}
    />
  );
};

export default MFAMethodItem;
